import * as React from 'react';
import { ProductListItem } from './ProductListItem';
import Section from './Section';
import { Product } from '../product';

const activeProducts = (items: Product[]) => {
  return items.filter((product: Product) => product.available);
};

const inactiveProducts = (items: Product[]) => {
  return items.filter((product: Product) => !product.available);
};

const renderItem = (product: Product, index: number) => (
  <ProductListItem product={product} key={index} index={index} />
);

type Props = {
  items: Product[];
};

export default function ProductsList(props: Props) {
  return (
    <React.Fragment>
      <Section title="Active">
        {activeProducts(props.items).map(renderItem)}
      </Section>
      {inactiveProducts(props.items).length > 0 && (
        <Section title="Taken down">
          {inactiveProducts(props.items).map(renderItem)}
        </Section>
      )}
    </React.Fragment>
  );
}
